import { useEffect } from 'react'
import { useQuery, useReactiveVar } from '@apollo/client'
import { useFragment } from '__generated__'
import { FRAGMENT_ME } from 'api/auth/fragment-me'
import { GET_ME } from 'api/auth/me'
import { guestSessionIdVar } from 'features/guest-session/store'
import {
  analyticsClient,
  analyticsIdentityVar,
  type AnalyticsIdentity
} from 'shared/analytics'

/**
 * Hands the analytics identity to the client (FE-321): the signed-in user,
 * else the guest session once it is known, else `null`, which holds the
 * queue. Mounted once at the app root.
 *
 * NOTE: the user comes from its own `me` query rather than `userVar`, which
 * only the header fills — and pages outside the main layout have none.
 */
export const AnalyticsEffect = () => {
  const { data } = useQuery(GET_ME)
  const userId = useFragment(FRAGMENT_ME, data?.me)?.id ?? null
  const guestSessionId = useReactiveVar(guestSessionIdVar)

  useEffect(() => {
    const identity: AnalyticsIdentity | null =
      userId ? { kind: 'user', id: userId }
      : guestSessionId ? { kind: 'guest', id: guestSessionId }
      : null

    analyticsIdentityVar(identity)
    analyticsClient.setIdentity(identity)
  }, [guestSessionId, userId])

  return null
}
